<template>
    <layout>

        <div class="container">
            <div style="max-width: 800px; margin: 0 auto;">
                <div v-if="componentLoaded" class="text-center text-white push-30"></div>
                <component v-if="componentLoaded" is="inspection-template" :inspection="inspection"></component>
            </div>
        </div>
    </layout>
</template>

<style media="all" lang="less">
    @import "../../assets/styles/app.less";
</style>

<script>
    export default {
        name: 'published',
        components: {
            layout: require('../layouts/published.vue')
        },
        data () {
            return {
                inspection: null,
                componentLoaded: false
            };
        },
        created () {
            let templateId = 'default1';
            this.axios.get('inspections/published/' + this.$route.params.token + '?include=region,status,parcels,inspector,contact').then((response) => {
                this.inspection = Object.assign(response.data, {template_id: templateId});
                this.$options.components['inspection-template'] = () => import('../async/inspections/inspection-' + this.inspection.template_id + '-published.vue');
                this.componentLoaded = true;
            });
        }
    };
</script>



// WEBPACK FOOTER //
// published.vue?b6b4158e